$(function () {
    $('.burger').on('click', function () {
        if($(this).hasClass('burger--open')) {
            $(this).removeClass('burger--open');
            $('.menu-mobile').removeClass('menu-mobile--open');
            $('body').css('overflow', 'unset');
            $('.header').addClass('box');
            // $('.box').not('.header').removeClass('box-hide');
        } else {
            $(this).addClass('burger--open');
            $('.menu-mobile').addClass('menu-mobile--open');
            $('body').css('overflow', 'hidden');
            $('.header').removeClass('box');
            // $('.box').not('.header').addClass('box-hide');
        }
    });

    if($(window).width() < 1200) {
        $('.menu-item-has-children-arrow').on('click', function () {
            if($(this).hasClass('menu-item-has-children-arrow--show')) {
                $(this).removeClass('menu-item-has-children-arrow--show');
                $(this).parent().find('.sub-menu').removeClass('sub-menu--show');
            } else {
                $(this).addClass('menu-item-has-children-arrow--show');
                $(this).parent().find('.sub-menu').addClass('sub-menu--show');
            }
        });


        $(document).on('click', (event) => { // событие клика по веб-документу
            let $div = $('.menu-item-has-children');
            if (!$div.is(event.target) // если клик был не по нашему блоку
                && $div.has(event.target).length === 0) { // и не по его дочерним элементам
                $('.menu-item-has-children-arrow').removeClass('menu-item-has-children-arrow--show');
                $('.sub-menu').removeClass('sub-menu--show');
                console.log('here');
            }
        });
    }

    if($('.menu-mobile__scrollbar').length) {
        $('.menu-mobile__scrollbar').mCustomScrollbar({
            scrollbarPosition: 'outside'
        });
    }

    var $selectric = $('.form_city').find('select');
    $selectric.selectric({
        disableOnMobile: false,
        nativeOnMobile: false
    });

    if($(window).width < 1200) {
        $('.menu-item').on('click', () => {
            $('.sub-menu').css('display', 'none');
        });
    }
});
